/**
 * Deux valeurs de filtre que Searchanise rend en anglais.
 *
 * DEPANNAGE, pas la correction. Ces libelles se reglent dans le panneau
 * Searchanise ; le compte n'est pas accessible d'ici, et la page ANGLAISE a
 * de toute facon un probleme plus grave que ce script ne peut pas resoudre
 * (toute son interface est servie en francais, faute d'un jeu de libelles par
 * langue). A retirer le jour ou l'app est configuree.
 *
 * Ce qui a ete mesure sur le live avant d'ecrire ceci :
 *
 *  - la rangee rendue est
 *      <li><label>
 *        <div class="snize-filter-checkbox">
 *          <input name="stock_status" value="In Stock"
 *                 data-se-facet-value-title="In Stock"
 *                 aria-label="In Stock, 49">
 *          <span class="needsclick"></span>
 *        </div>
 *        <span class="needsclick">In Stock<span class="snize-filter-variant-count">49</span></span>
 *      </label></li>
 *
 *  - `value` EST la valeur fonctionnelle : l'etat filtre s'ecrit dans l'URL
 *    sous la forme `?rb_stock_status=In%20Stock`. La traduire casserait le
 *    filtrage en silence. On ne touche donc NI `value`, NI `name`, NI
 *    `data-se-facet-value-title` : ils servent d'identifiant, pas d'affichage.
 *    Seul le noeud de texte visible est reecrit, plus l'aria-label, qui lui
 *    n'est que de l'accessibilite ;
 *
 *  - le compteur (« 49 ») est un span IMBRIQUE dans le meme span que le
 *    texte. On remplace donc le premier noeud de texte, pas le innerHTML,
 *    sinon le compteur disparait ;
 *
 *  - PREMIERE VERSION, qui ne marchait pas : elle gardait une reference vers
 *    #snize_results et observait CE noeud. Au moment ou le script s'execute
 *    (defer), le conteneur present est encore le squelette pose par le corps
 *    de la page ; Searchanise le REMPLACE ensuite, et l'observateur se
 *    retrouvait sur un noeud detache. Aucune erreur, aucun effet. C'est le
 *    meme piege que celui deja documente dans chapman-snize-chips.js a propos
 *    des noeuds cliques. On ne garde donc AUCUNE reference : on observe
 *    document.body et on re-interroge le DOM a chaque passe.
 *
 * 2026-10-23 : meme traitement pour le TITRE d'un filtre, « Fournisseur »
 * (le champ vendor de Shopify) qui devient « Marque ». Le titre est un simple
 * <span> dans div.snize-product-filters-title, sans role fonctionnel : on en
 * remplace le texte, rien d'autre.
 *
 * Les textes viennent des fichiers de locale du theme, via
 * window.ChapmanSnizeLabels : /en sert donc l'anglais d'origine et le
 * remplacement devient un non-evenement, sans detection de langue.
 */
(function () {
  'use strict';

  var S = window.ChapmanSnizeLabels || {};

  /* identifiant fonctionnel -> texte a afficher */
  var MAP = [
    { name: 'stock_status', value: 'In Stock', label: S.stockIn },
    { name: 'discount_relative', value: 'No discount', label: S.discountNone }
  ].filter(function (e) {
    /* rien a faire si la locale rend le texte d'origine (cas de /en) */
    return e.label && e.label !== e.value;
  });

  /* titre de filtre affiche -> texte a afficher */
  var TITRES = [
    { from: 'Fournisseur', label: S.vendorTitle }
  ].filter(function (e) {
    return e.label && e.label !== e.from;
  });

  if (!MAP.length && !TITRES.length) return;

  var obs = null;
  var enAttente = false;

  function premierTexte(span) {
    for (var i = 0; i < span.childNodes.length; i++) {
      if (span.childNodes[i].nodeType === 3 &&
          span.childNodes[i].nodeValue.trim()) {
        return span.childNodes[i];
      }
    }
    return null;
  }

  function passeTitres() {
    if (!TITRES.length) return;
    var spans = document.querySelectorAll('#snize_results .snize-product-filters-title span');
    for (var i = 0; i < spans.length; i++) {
      var noeud = premierTexte(spans[i]);
      if (!noeud) continue;
      for (var j = 0; j < TITRES.length; j++) {
        if (noeud.nodeValue.trim() === TITRES[j].from) {
          noeud.nodeValue = TITRES[j].label;
        }
      }
    }
  }

  function passe() {
    passeTitres();
    MAP.forEach(function (e) {
      /* requete depuis le document : aucune reference conservee */
      var sel = '#snize_results input[name="' + e.name +
                '"][value="' + e.value + '"]';
      var inputs = document.querySelectorAll(sel);
      for (var i = 0; i < inputs.length; i++) {
        var label = inputs[i].closest('label');
        if (!label) continue;

        var spans = label.querySelectorAll('span.needsclick');
        for (var j = 0; j < spans.length; j++) {
          var noeud = premierTexte(spans[j]);
          if (!noeud) continue;                    /* le span de la case */
          if (noeud.nodeValue.trim() !== e.value) continue;  /* deja fait */
          noeud.nodeValue = e.label;
        }

        /* aria-label : "In Stock, 49" -> "En stock, 49". Purement
           accessibilite, aucun role fonctionnel. */
        var aria = inputs[i].getAttribute('aria-label');
        if (aria && aria.indexOf(e.value) === 0) {
          inputs[i].setAttribute('aria-label', e.label + aria.slice(e.value.length));
        }
      }
    });
  }

  /* Searchanise rebatit la colonne a chaque changement, et par rafales :
     on regroupe les mutations d'une meme rafale en une seule passe, et on
     suspend l'observateur pendant l'ecriture pour ne pas se relancer soi
     meme. La passe est de toute facon idempotente (elle ne reecrit que ce
     qui porte encore le texte d'origine), donc une rafale manquee est
     rattrapee par la suivante.

     setTimeout et NON requestAnimationFrame : rAF ne s'execute pas dans un
     onglet qui ne peint pas, et un onglet d'arriere plan est exactement le
     cas d'un client qui ouvre la recherche dans un nouvel onglet. Mesure :
     dans un contexte ou document.visibilityState vaut pourtant 'visible',
     rAF n'avait toujours pas tire apres 1,5 s alors que setTimeout, si. */
  function planifier() {
    if (enAttente) return;
    enAttente = true;
    setTimeout(function () {
      enAttente = false;
      if (obs) obs.disconnect();
      try {
        passe();
      } finally {
        if (obs) {
          obs.observe(document.body, { childList: true, subtree: true });
        }
      }
    });
  }

  function demarrer() {
    obs = new MutationObserver(planifier);
    obs.observe(document.body, { childList: true, subtree: true });
    planifier();
  }

  if (document.body) {
    demarrer();
  } else {
    document.addEventListener('DOMContentLoaded', demarrer);
  }
})();
